import React from "react"
import { Slide, Snackbar } from "@mui/material"
import useMediaQuery from "@mui/material/useMediaQuery"

import SnackbarContentWrapper from "molecules/SnackbarContentWrapper"
import useSnackBar from "hooks/useSnackBar"

const TransitionLeft = (props) => {
  return <Slide {...props} direction="left" />
}

const TransitionUp = (props) => {
  return <Slide {...props} direction="up" />
}

const SnackbarWrapper = () => {
  const { snackbar, closeSnackbar } = useSnackBar()
  const handleClose = () => {
    closeSnackbar()
  }
  const isTabletPC = useMediaQuery("(min-width:600px)")
  const anchorPosition = isTabletPC
    ? {
        vertical: "top",
        horizontal: "right",
      }
    : {
        vertical: "bottom",
        horizontal: "center",
      }
  const transition = isTabletPC ? TransitionLeft : TransitionUp
  return (
    <Snackbar
      id="snackbar"
      anchorOrigin={anchorPosition}
      open={snackbar.isOpen}
      autoHideDuration={6000}
      onClose={handleClose}
      TransitionComponent={transition}
    >
      <SnackbarContentWrapper
        variant={snackbar.variant}
        message={snackbar.message}
        onClose={handleClose}
      />
    </Snackbar>
  )
}

export default SnackbarWrapper
